import type { Environment } from '@livecontrol/command-center/frontend';

export const environment: Readonly<Environment> = Object.freeze({
  production: true,
  COGNITO_POOL_ID: 'us-west-1_GrbQHNoaU',
  COGNITO_APP_CLIENT_ID: 'j00iofiipb5aagv07lksc77m5',
  // GRAPHQL_URI: 'https://7xgg7vnfjfaqhdfubc5l4x2slm.appsync-api.us-west-1.amazonaws.com',
  GRAPHQL_URI: 'https://scheduler-graphql.api.livecontrol.io',
  APPSYNC_REGION: 'us-west',
  WEBPLAYER_CONTROL_URI: 'https://venue.api.livecontrol.io',
  DEMO_CUSTOMER_IDS: [1090, 1490, 1618, 1640, 1931],
  VERSION: '2.6.1',
  WEBSOCKET_URI: 'wss://scheduler-graphql.api.livecontrol.io/graphql',
  DASHBOARD_URI: 'https://dashboard.livecontrol.io',
  ADMIN_DASHBOARD_URI: 'https://admin.internal.livecontrol.io',
  EVENTS_WEBSOCKET: 'wss://scheduler-ws.api.livecontrol.io',
  SERVERLESS_URL: 'https://bsnm82l4m2.execute-api.us-west-1.amazonaws.com/prod',
  SERVERLESS_WEBSOCKET: 'wss://pj3u2tzww7.execute-api.us-west-1.amazonaws.com/prod'
});
